export const buildNumber = '20260427.5';
export const version = 'main';
export const latestCommit = '99e16432b7860afe29b3690ba8f4167fc92e491e';
